export default function () {
  const dateParagraph = document.querySelector('.update-date__text');
  const formattedDate = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long' });

  dateParagraph.innerText = `Updated for ${formattedDate}`
}
